/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchasePortalResponse } from '../../models/purchase-portal-response';

export interface GetProfilePortalAccessUrl$Params {

/**
 * ID of profile
 */
  id: number;
}

export function getProfilePortalAccessUrl(http: HttpClient, rootUrl: string, params: GetProfilePortalAccessUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchasePortalResponse>> {
  const rb = new RequestBuilder(rootUrl, getProfilePortalAccessUrl.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchasePortalResponse>;
    })
  );
}

getProfilePortalAccessUrl.PATH = '/rest/profile/{id}/purchase/portal';
